var slider_controller = {
    instances: {},
    selector: '.syn-hero-container .slides',
    slide_selector: '.slide',
    init: function(){
        var sliders = jQuery(this.selector);
        if(sliders.length > 0){
            sliders.each(function(){
                var $this = jQuery(this);
                var $container = $this.closest('.syn-hero-container')
                var id = $container.prop('id');
                var slides = $this.find(slider_controller.slide_selector);
                if(slides.length > 1){
                    var options = $container.data('options');
                    var slider_options = {
                        autoplay: false,
                        autoplaySpeed: 7000,
                        arrows: false,
                        dots: false,
                        speed: 300,
                        prevArrow: '<button type="button" class="icon slick-prev icon-arrow-left" aria-label="previous"></button>',
                        nextArrow: '<button type="button" class="icon slick-next icon-arrow-right" aria-label="next"></button>',
                    };
                    for(i in slider_options){
                        if(typeof options[i] != 'undefined'){
                            if(options[i] == 'true'){
                                options[i] = true;
                            }else if(options[i] == 'false'){
                                options[i] = false;
                            }else if(typeof options[i] != 'object'){
                                options[i] = Number(options[i]);
                            }
                            slider_options[i] = options[i];
                        }
                    }
                    slider_controller.instances[id] = $this.slick(slider_options);
                }
            });
        }
    }
};

jQuery(document).ready(function(){
    slider_controller.init();
});